export default "__VITE_ASSET__BG3oaP65__"